// src/components/PrivacyConsent.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

type Props = {
  checked: boolean;
  onChange: (v: boolean) => void;
  compact?: boolean;
};

export function PrivacyConsent({ checked, onChange, compact }: Props) {
  const navigate = useNavigate();

  // מניעת toggle של הצ'קבוקס כשנלחץ על הלינק
  const stop = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  // נווט בתוך האפליקציה (עובד גם ב-Capacitor). בדפדפן רגיל תרצה אולי לפתוח בטאב חדש.
  const openPolicy = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    navigate('/privacy'); // ← אם תרצה טאב חדש בדפדפן: window.open('/privacy', '_blank', 'noopener,noreferrer');
  };

  return (
    <div className={`${compact ? 'text-xs' : 'text-sm'} text-gray-700`}>
      <div className="flex items-start gap-2">
        <input
          type="checkbox"
          className="mt-1 h-4 w-4 rounded border-gray-300"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          id="pp-consent"
        />
        <div>
          <label htmlFor="pp-consent" className="cursor-pointer select-none">
            קראתי ואני מאשר/ת את{' '}
          </label>

          {/* קישור נפרד מה־label + עצירת bubbling */}
          <a
            href="/privacy"
            onClick={openPolicy}
            onMouseDown={stop}
            onTouchStart={stop}
            className="text-indigo-600 underline underline-offset-2"
          >
            מדיניות הפרטיות
          </a>
          .
        </div>
      </div>
    </div>
  );
}
